import { GetterTree } from 'vuex';
import { ReactionState } from './state';
import RootState from '@/store/root_state';
import { ContentReactions } from '@/models/ReactionsModel';

const getters: GetterTree<ReactionState, RootState> = {
  getContentReactions:
    (state, reactionsGetters) =>
    (contentId: string): ContentReactions | null => {
      const contentReactions = state.reactions[contentId];
      return contentReactions ? new ContentReactions(contentReactions, reactionsGetters) : null;
    },
};

export default getters;
